var _circle, _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntercom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 15,
    fill: "#fff",
    fillOpacity: 0.2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 15,
    fill: "#fff",
    fillOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.297 26.324a2.027 2.027 0 012.027-2.027h12.163a2.027 2.027 0 012.027 2.027v8.108a2.027 2.027 0 01-2.027 2.027H28.77c-.269 0-.527.107-.716.297l-2.892 2.892a.506.506 0 01-.866-.358V26.324zm3.548 1.014a.507.507 0 000 1.013h9.121a.506.506 0 100-1.013h-9.121zm0 2.534a.507.507 0 000 1.013h9.121a.507.507 0 000-1.013h-9.121zm0 2.533a.507.507 0 000 1.014h5.067a.507.507 0 000-1.014h-5.067z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(24.297 24.297)",
    d: "M0 0h16.216v16.216H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercom);
export default __webpack_public_path__ + "static/media/Intercom.7b5ab156b6abc7e53094c032d9ce247c.svg";
export { ForwardRef as ReactComponent };